export const DASHBOARD_BASE_URL = process.env.REACT_APP_DASHBOARD_BASE_URL;
export const OCTOPUS_BASE_URL = process.env.REACT_APP_OCTOPUS_BASE_URL;
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const SMR_URL = process.env.REACT_APP_SMR_URL;
export const EVENTS_BASE_URL = process.env.REACT_APP_EVENTS_BASE_URL;
export const SEARCH_ORCHESTRATOR_BASE_URL = process.env.REACT_APP_SEARCH_ORCHESTRATOR_BASE_URL;
export const ISSUE_SERVICE_URL = process.env.REACT_APP_ISSUE_SERVICE_URL;
export const ORIGIN = process.env.REACT_APP_ORIGIN;
